export default "__VITE_ASSET__wcbO_HbB__"